export const WIDGET_BOX_SHADOW_SIZE_PX = 35;
